"use client";

import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import { usePermissions } from "@/context/permissions-context";
import { fetchData } from "@/utils/api-handler";
import type { IntegrationLookupRow } from "@/utils/command-agent-expired-integrations";

/**
 * Shared integrations catalog rows (status, name) for resolving expired
 * connections on Command agents without fetching each agent individually.
 */
export function useIntegrationsAppsLookup(enabled = true) {
    const { hasAllPermissions } = usePermissions();
    const canListIntegrations = hasAllPermissions(["LIST_APP_INTEGRATIONS"]);

    const { data, isLoading } = useQuery<{ items: IntegrationLookupRow[] }>({
        queryKey: ["integrations-apps-lookup"],
        queryFn: async () => {
            const params = new URLSearchParams({ page: "1", limit: "50" });
            return fetchData(`/api/integrations/apps?${params.toString()}`);
        },
        enabled: enabled && canListIntegrations,
        staleTime: 60_000,
    });

    const lookupItems = useMemo(() => data?.items ?? [], [data?.items]);

    return { lookupItems, isLoadingLookup: isLoading };
}
